import { useNavigator } from '@repo/toolkit/use-navigator'
import Button from '@repo/ui/button'
import { ChevronLeftIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { Paths } from '../../lib/constants/path'

const NotFoundPage = () => {
  const { navigate } = useNavigator()
  return (
    <div className={'h-screen p-5'}>
      <div
        className={
          'w-full h-full flex justify-center items-center flex-col bg-white-light rounded-2xl'
        }
      >
        <div className={'flex justify-center items-center flex-col gap-[38px]'}>
          <img src="/page-not-found.png" alt="page not found" className={'w-[400px] h-[421px]'} />

          <div className={'flex justify-center items-center flex-col gap-[10px]'}>
            <Typography variant={'h2'}>Page non trouvée</Typography>

            <Button
              icon={ChevronLeftIcon}
              variant={'outline'}
              label={'Retour'}
              onClick={() => navigate(Paths.DEFAULT_PAGE)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
